import React from 'react';
import { useStore } from '../../stores';

export const Description = () => {

  const { poi, config } = useStore();
    
  return (
    <div className="my-8 text-neutral-600 text-lg">
      {poi.active[config.gysService.language]?.description || ''}
    </div>
  );
  
};